<template>
    <b-container fluid>
        <b-row class="mb-3">
            <b-col v-if="!photo">
                <video
                    ref="video"
                    class="video"
                ></video>
            </b-col>
            <b-col v-else>
                <b-img :src="photo" class="photo-preview"></b-img>
            </b-col>
        </b-row>
        <b-form-row>
            <b-col cols="10">
                <b-btn variant="primary" v-if="!photo" block @click="capture"><i class="fa fa-camera"></i></b-btn>
                <b-btn variant="danger" v-else block @click="remove"><i class="fa fa-trash"></i></b-btn>
            </b-col>
            <b-col>
                <b-btn block variant="primary" :disabled="!!photo"><i class="fa fa-refresh" @click="changeCamera"></i></b-btn>
            </b-col>
        </b-form-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        mediaStream: null,
        video: null,
        devices: null,
        photo: '',
        facingMode: 'environment'
    }),
    methods: {
        getDevices() {
            if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.enumerateDevices()
                .then(devices => {
                    this.devices = devices.filter(item => item.kind === 'videoinput').map((item, index) => ({ deviceId: item.deviceId, label: item.label || `Camara ${index + 1}` }));
                })
            }
        },
        playVideo() {
            this.video = this.$refs.video;
            navigator.getUserMedia = navigator.getUserMedia ||
                            navigator.webkitGetUserMedia ||
                            navigator.mozGetUserMedia ||
                            navigator.mediaDevices.getUserMedia;

            navigator.getUserMedia({video: {facingMode: this.facingMode }, audio: false }, stream => {
                    this.mediaStream = stream;
                    this.video.srcObject = stream;
                    this.video.onloadedmetadata = e => {
                        this.video.play();
                    }
            }, error => {

            });
        },
        turnOff() {
            const tracks = this.mediaStream.getTracks();
            tracks.map(track => track.stop());
            this.video.srcObject = null;
        },
        changeCamera() {
            const modes = {
                user: 'environment',
                environment: 'user'
            };

            this.facingMode = modes[this.facingMode];

            this.turnOff();
            this.playVideo();
        },
        capture() {
            const track = this.mediaStream.getVideoTracks()[0];
            const imageCapture = new ImageCapture(track);
            return imageCapture.takePhoto().then(blob => {
                

                const fileReader = new FileReader();
                fileReader.onloadend = () => {
                    this.photo = fileReader.result;
                    this.$emit('input', this.photo);
                    this.turnOff();
                }
                fileReader.readAsDataURL(blob);

            });
        },
        remove() {
            this.photo = '';
            
            this.$nextTick(() => this.playVideo());
            this.$emit('input', null);
        }
    },
    mounted() {
        this.getDevices();
        this.playVideo();

        this.$bus.$on('camera.on', this.playVideo);
        this.$bus.$on('camera.off', this.turnOff);
    },
    beforeDestroy() {
        this.$bus.$off('camera.on');
        this.$bus.$off('camera.off');
    },
}
</script>
<style lang="scss">
    .video {
        width: 100%;
    }
    .photo-preview {
        max-width: 100%;
    }
</style>